//const baseUrl= 'http://13.127.71.165:5400/';     ///ONLINE WAGON
//const baseUrl = 'http://13.127.71.165:5600/';     ///ONLINE EMG

//const baseUrl= 'http://103.212.120.163:5200/';     ///ONLINE
//const baseUrl = 'http://200.1.50.108:5200/';

//const baseUrl = 'http://200.1.50.108:5200/';

//const baseUrl= 'http://localhost:5200/';    
//const baseUrl= 'http://192.168.0.181:5200/';    
//const baseUrl = 'http://103.212.120.163:5200/';     ///ONLINE

const baseUrl = 'https://api.renohrm.com/';     ///ONLINE

export const AppSettings = {

  //Company
  insertCompanyUrl: baseUrl + 'company/insertcompany',
  setCompanyUrl: baseUrl + 'company/setcompany',
  checkCompanyUrl: baseUrl + 'company/checkcompany',
  getCompanyUrl: baseUrl + 'company/getcompany',
  deleteCompanyUrl: baseUrl + 'company/deletecompany',
  getcompanycheckdetailsUrl: baseUrl + 'company/getcompanycheckdetails',
  insertCompanyRegistrationUrl: baseUrl + 'company/insertcompanyregistration',

  //Branch
  insertBranchUrl: baseUrl + 'branch/insertbranch',
  setBranchUrl: baseUrl + 'branch/setbranch',
  checkBranchUrl: baseUrl + 'branch/checkbranch',
  getBranchUrl: baseUrl + 'branch/getbranch',
  deleteBranchUrl: baseUrl + 'branch/deletebranch',

  //Allowance
  insertAllowanceUrl: baseUrl + 'allowance/insertallowance',
  setAllowanceUrl: baseUrl + 'allowance/setallowance',
  checkAllowanceUrl: baseUrl + 'allowance/checkallowance',
  getAllowanceUrl: baseUrl + 'allowance/getallowance',
  deleteAllowanceUrl: baseUrl + 'allowance/deleteallowance',

  //Asset Type
  insertAssetTypeUrl: baseUrl + 'assettype/insertassettype',
  setAssetTypeUrl: baseUrl + 'assettype/setassettype',
  checkAssetTypeUrl: baseUrl + 'assettype/checkassettype',
  getAssetTypeUrl: baseUrl + 'assettype/getassettype',
  deleteAssetTypeUrl: baseUrl + 'assettype/deleteassettype',

  //Bonus Type
  insertBonusTypeUrl: baseUrl + 'bonustype/insertbonustype',
  setBonusTypeUrl: baseUrl + 'bonustype/setbonustype',
  checkBonusTypeUrl: baseUrl + 'bonustype/checkbonustype',
  getBonusTypeUrl: baseUrl + 'bonustype/getbonustype',
  deleteBonusTypeUrl: baseUrl + 'bonustype/deletebonustype',

  //Department
  insertDepartmentUrl: baseUrl + 'department/insertdepartment',
  setDepartmentUrl: baseUrl + 'department/setdepartment',
  checkDepartmentUrl: baseUrl + 'department/checkdepartment',
  getDepartmentUrl: baseUrl + 'department/getdepartment',
  deleteDepartmentUrl: baseUrl + 'department/deletedepartment',

  //Deduction
  insertDeductionUrl: baseUrl + 'deduction/insertdeduction',
  setDeductionUrl: baseUrl + 'deduction/setdeduction',
  checkDeductionUrl: baseUrl + 'deduction/checkdeduction',
  getDeductionUrl: baseUrl + 'deduction/getdeduction',
  deleteDeductionUrl: baseUrl + 'deduction/deletededuction',

  //Designation
  insertDesignationUrl: baseUrl + 'designation/insertdesignation',
  setDesignationUrl: baseUrl + 'designation/setdesignation',
  checkDesignationUrl: baseUrl + 'designation/checkdesignation',
  getDesignationUrl: baseUrl + 'designation/getdesignation',
  deleteDesignationUrl: baseUrl + 'designation/deletedesignation',

  getDesignationCompanyUrl: baseUrl + 'designation/getdesignationcompany',

  //EmpType
  insertEmpTypeUrl: baseUrl + 'emptype/insertemptype',
  setEmpTypeUrl: baseUrl + 'emptype/setemptype',
  checkEmpTypeUrl: baseUrl + 'emptype/checkemptype',
  getEmpTypeUrl: baseUrl + 'emptype/getemptype',
  deleteEmpTypeUrl: baseUrl + 'emptype/deleteemptype',

  //ExpenseType
  insertExpenseTypeUrl: baseUrl + 'expensetype/insertexpensetype',
  setExpenseTypeUrl: baseUrl + 'expensetype/setexpensetype',
  checkExpenseTypeUrl: baseUrl + 'expensetype/checkexpensetype',
  getExpenseTypeUrl: baseUrl + 'expensetype/getexpensetype',
  deleteExpenseTypeUrl: baseUrl + 'expensetype/deleteexpensetype',

  //Gender
  insertGenderUrl: baseUrl + 'gender/insertgender',
  setGenderUrl: baseUrl + 'gender/setgender',
  checkGenderUrl: baseUrl + 'gender/checkgender',
  getGenderUrl: baseUrl + 'gender/getgender',
  deleteGenderUrl: baseUrl + 'gender/deletegender',

  //Grade
  insertGradeUrl: baseUrl + 'grade/insertgrade',
  setGradeUrl: baseUrl + 'grade/setgrade',
  checkGradeUrl: baseUrl + 'grade/checkgrade',
  getGradeUrl: baseUrl + 'grade/getgrade',
  deleteGradeUrl: baseUrl + 'grade/deletegrade',

  //IncidentType
  insertIncidentTypeUrl: baseUrl + 'incidenttype/insertincidenttype',
  setIncidentTypeUrl: baseUrl + 'incidenttype/setincidenttype',
  checkIncidentTypeUrl: baseUrl + 'incidenttype/checkincidenttype',
  getIncidentTypeUrl: baseUrl + 'incidenttype/getincidenttype',
  deleteIncidentTypeUrl: baseUrl + 'incidenttype/deleteincidenttype',

  //LeaveType
  insertLeaveTypeUrl: baseUrl + 'leavetype/insertleavetype',
  setLeaveTypeUrl: baseUrl + 'leavetype/setleavetype',
  checkLeaveTypeUrl: baseUrl + 'leavetype/checkleavetype',
  getLeaveTypeUrl: baseUrl + 'leavetype/getleavetype',
  getLeaveTypeByEmpidUrl: baseUrl + 'leavetype/getleavetypebyempid',
  deleteLeaveTypeUrl: baseUrl + 'leavetype/deleteleavetype',


  //LoanType
  insertLoanTypeUrl: baseUrl + 'loantype/insertloantype',
  setLoanTypeUrl: baseUrl + 'loantype/setloantype',
  checkLoanTypeUrl: baseUrl + 'loantype/checkloantype',
  getLoanTypeUrl: baseUrl + 'loantype/getloantype',
  deleteLoanTypeUrl: baseUrl + 'loantype/deleteloantype',

  //Location
  insertLocationUrl: baseUrl + 'location/insertlocation',
  setLocationUrl: baseUrl + 'location/setlocation',
  checkLocationUrl: baseUrl + 'location/checklocation',
  getLocationUrl: baseUrl + 'location/getlocation',
  deleteLocationUrl: baseUrl + 'location/deletelocation',

  //MaritalStatus
  insertMaritalStatusUrl: baseUrl + 'maritalstatus/insertmaritalstatus',
  setMaritalStatusUrl: baseUrl + 'maritalstatus/setmaritalstatus',
  checkMaritalStatusUrl: baseUrl + 'maritalstatus/checkmaritalstatus',
  getMaritalStatusUrl: baseUrl + 'maritalstatus/getmaritalstatus',
  deleteMaritalStatusUrl: baseUrl + 'maritalstatus/deletemaritalstatus',

  //MemoType
  insertMemoTypeUrl: baseUrl + 'memotype/insertmemotype',
  setMemoTypeUrl: baseUrl + 'memotype/setmemotype',
  checkMemoTypeUrl: baseUrl + 'memotype/checkmemotype',
  getMemoTypeUrl: baseUrl + 'memotype/getmemotype',
  deleteMemoTypeUrl: baseUrl + 'memotype/deletememotype',

  //OverTimeType
  insertOverTimeTypeUrl: baseUrl + 'overtimetype/insertovertimetype',
  setOverTimeTypeUrl: baseUrl + 'overtimetype/setovertimetype',
  checkOverTimeTypeUrl: baseUrl + 'overtimetype/checkovertimetype',
  getOverTimeTypeUrl: baseUrl + 'overtimetype/getovertimetype',
  deleteOverTimeTypeUrl: baseUrl + 'overtimetype/deleteovertimetype',

  //PayMode
  insertPayModeUrl: baseUrl + 'paymode/insertpaymode',
  setPayModeUrl: baseUrl + 'paymode/setpaymode',
  checkPayModeUrl: baseUrl + 'paymode/checkpaymode',
  getPayModeUrl: baseUrl + 'paymode/getpaymode',
  deletePayModeUrl: baseUrl + 'paymode/deletepaymode',

  //Payrollgrp
  insertPayrollgrpUrl: baseUrl + 'payrollgrp/insertpayrollgrp',
  setPayrollgrpUrl: baseUrl + 'payrollgrp/setpayrollgrp',
  checkPayrollgrpUrl: baseUrl + 'payrollgrp/checkpayrollgrp',
  getPayrollgrpUrl: baseUrl + 'payrollgrp/getpayrollgrp',
  deletePayrollgrpUrl: baseUrl + 'payrollgrp/deletepayrollgrp',

  //ReimburseType
  insertReimburseTypeUrl: baseUrl + 'reimbursetype/insertreimbursetype',
  setReimburseTypeUrl: baseUrl + 'reimbursetype/setreimbursetype',
  checkReimburseTypeUrl: baseUrl + 'reimbursetype/checkreimbursetype',
  getReimburseTypeUrl: baseUrl + 'reimbursetype/getreimbursetype',
  deleteReimburseTypeUrl: baseUrl + 'reimbursetype/deletereimbursetype',

  //Relationship
  insertRelationshipUrl: baseUrl + 'relationship/insertrelationship',
  setRelationshipUrl: baseUrl + 'relationship/setrelationship',
  checkRelationshipUrl: baseUrl + 'relationship/checkrelationship',
  getRelationshipUrl: baseUrl + 'relationship/getrelationship',
  deleteRelationshipUrl: baseUrl + 'relationship/deleterelationship',

  //RelieveType
  insertRelieveTypeUrl: baseUrl + 'relievetype/insertrelievetype',
  setRelieveTypeUrl: baseUrl + 'relievetype/setrelievetype',
  checkRelieveTypeUrl: baseUrl + 'relievetype/checkrelievetype',
  getRelieveTypeUrl: baseUrl + 'relievetype/getrelievetype',
  deleteRelieveTypeUrl: baseUrl + 'relievetype/deleterelievetype',

  //Skills
  insertSkillsUrl: baseUrl + 'skills/insertskills',
  setSkillsUrl: baseUrl + 'skills/setskills',
  checkSkillsUrl: baseUrl + 'skills/checkskills',
  getSkillsUrl: baseUrl + 'skills/getskills',
  deleteSkillsUrl: baseUrl + 'skills/deleteskills',

  //UserRole
  insertUserRoleUrl: baseUrl + 'userrole/insertuserrole',
  setUserRoleUrl: baseUrl + 'userrole/setuserrole',
  checkUserRoleUrl: baseUrl + 'userrole/checkuserrole',
  getUserRoleUrl: baseUrl + 'userrole/getuserrole',
  deleteUserRoleUrl: baseUrl + 'userrole/deleteuserrole',
  getUserRoleRightsUserUrl: baseUrl + 'userrole/getuserrolerightsbyuserid',
  getUserRoleRightsUrl: baseUrl + 'userrole/getuserrolerights',

  //User
  insertUserUrl: baseUrl + 'user/insertuser',
  setUserUrl: baseUrl + 'user/setuser',
  checkUserUrl: baseUrl + 'user/checkuser',
  getUserUrl: baseUrl + 'user/getuser',
  getLoginUserUrl: baseUrl + 'user/getloginuser',
  deleteUserUrl: baseUrl + 'user/deleteuser',

  //Asset
  insertAssetUrl: baseUrl + 'asset/insertasset',
  setAssetUrl: baseUrl + 'asset/setasset',
  checkAssetUrl: baseUrl + 'asset/checkasset',
  getAssetUrl: baseUrl + 'asset/getasset',
  getAssetListviewUrl: baseUrl + 'asset/getassetlistview',
  deleteAssetUrl: baseUrl + 'asset/deleteasset',
  getAssetAvailableUrl: baseUrl + 'asset/getassetbyavailable',

  //Holidays
  insertHolidaysUrl: baseUrl + 'holidays/insertholidays',
  setHolidaysUrl: baseUrl + 'holidays/setholidays',
  checkHolidaysUrl: baseUrl + 'holidays/checkholidays',
  getHolidaysUrl: baseUrl + 'holidays/getholidays',
  getHolidaysListviewUrl: baseUrl + 'holidays/getholidayslistview',
  deleteHolidaysUrl: baseUrl + 'holidays/deleteholidays',

  //Religion
  insertReligionUrl: baseUrl + 'religion/insertreligion',
  setReligionUrl: baseUrl + 'religion/setreligion',
  checkReligionUrl: baseUrl + 'religion/checkreligion',
  getReligionUrl: baseUrl + 'religion/getreligion',
  deleteReligionUrl: baseUrl + 'religion/deletereligion',

  //Sponser
  insertSponserUrl: baseUrl + 'sponser/insertsponser',
  setSponserUrl: baseUrl + 'sponser/setsponser',
  checkSponserUrl: baseUrl + 'sponser/checksponser',
  getSponserUrl: baseUrl + 'sponser/getsponser',
  deleteSponserUrl: baseUrl + 'sponser/deletesponser',

  //ContractType
  insertContractTypeUrl: baseUrl + 'contracttype/insertcontracttype',
  setContractTypeUrl: baseUrl + 'contracttype/setcontracttype',
  checkContractTypeUrl: baseUrl + 'contracttype/checkcontracttype',
  getContractTypeUrl: baseUrl + 'contracttype/getcontracttype',
  deleteContractTypeUrl: baseUrl + 'contracttype/deletecontracttype',

  //Category
  insertCategoryUrl: baseUrl + 'category/insertcategory',
  setCategoryUrl: baseUrl + 'category/setcategory',
  checkCategoryUrl: baseUrl + 'category/checkcategory',
  getCategoryUrl: baseUrl + 'category/getcategory',
  deleteCategoryUrl: baseUrl + 'category/deletecategory',

  //PayType
  insertPayTypeUrl: baseUrl + 'paytype/insertpaytype',
  setPayTypeUrl: baseUrl + 'paytype/setpaytype',
  checkPayTypeUrl: baseUrl + 'paytype/checkpaytype',
  getPayTypeUrl: baseUrl + 'paytype/getpaytype',
  deletePayTypeUrl: baseUrl + 'paytype/deletepaytype',

  //WpsGroup
  insertWpsGroupUrl: baseUrl + 'wpsgroup/insertwpsgroup',
  setWpsGroupUrl: baseUrl + 'wpsgroup/setwpsgroup',
  checkWpsGroupUrl: baseUrl + 'wpsgroup/checkwpsgroup',
  getWpsGroupUrl: baseUrl + 'wpsgroup/getwpsgroup',
  deleteWpsGroupUrl: baseUrl + 'wpsgroup/deletewpsgroup',


  //Bank
  insertBankUrl: baseUrl + 'bank/insertbank',
  setBankUrl: baseUrl + 'bank/setbank',
  checkBankUrl: baseUrl + 'bank/checkbank',
  getBankUrl: baseUrl + 'bank/getbank',
  deleteBankUrl: baseUrl + 'bank/deletebank',

  //Status
  insertStatusUrl: baseUrl + 'status/insertstatus',
  setStatusUrl: baseUrl + 'status/setstatus',
  checkStatusUrl: baseUrl + 'status/checkstatus',
  getStatusUrl: baseUrl + 'status/getstatus',
  deleteStatusUrl: baseUrl + 'status/deletestatus',


  //LeavePolicy
  insertLeavePolicyUrl: baseUrl + 'leavepolicy/insertleavepolicy',
  setLeavePolicyUrl: baseUrl + 'leavepolicy/setleavepolicy',
  checkLeavePolicyUrl: baseUrl + 'leavepolicy/checkleavepolicy',
  getLeavePolicyUrl: baseUrl + 'leavepolicy/getleavepolicy',
  deleteLeavePolicyUrl: baseUrl + 'leavepolicy/deleteleavepolicy',
  getLeavePolicyListviewUrl: baseUrl + 'leavepolicy/getleavepolicylistview',


  //AccomType
  insertAccomTypeUrl: baseUrl + 'accomtype/insertaccomtype',
  setAccomTypeUrl: baseUrl + 'accomtype/setaccomtype',
  checkAccomTypeUrl: baseUrl + 'accomtype/checkaccomtype',
  getAccomTypeUrl: baseUrl + 'accomtype/getaccomtype',
  deleteAccomTypeUrl: baseUrl + 'accomtype/deleteaccomtype',

  //Salution
  insertSalutionUrl: baseUrl + 'salution/insertsalution',
  setSalutionUrl: baseUrl + 'salution/setsalution',
  checkSalutionUrl: baseUrl + 'salution/checksalution',
  getSalutionUrl: baseUrl + 'salution/getsalution',
  deleteSalutionUrl: baseUrl + 'salution/deletesalution',

  //HiResource
  insertHiResourceUrl: baseUrl + 'hiresource/inserthiresource',
  setHiResourceUrl: baseUrl + 'hiresource/sethiresource',
  checkHiResourceUrl: baseUrl + 'hiresource/checkhiresource',
  getHiResourceUrl: baseUrl + 'hiresource/gethiresource',
  deleteHiResourceUrl: baseUrl + 'hiresource/deletehiresource',

  //DocType
  insertDocTypeUrl: baseUrl + 'doctype/insertdoctype',
  setDocTypeUrl: baseUrl + 'doctype/setdoctype',
  checkDocTypeUrl: baseUrl + 'doctype/checkdoctype',
  getDocTypeUrl: baseUrl + 'doctype/getdoctype',
  deleteDocTypeUrl: baseUrl + 'doctype/deletedoctype',

  //Nationality
  getNationalityUrl: baseUrl + 'nationality/getnationality',

  //BloodGroup
  getBloodGroupUrl: baseUrl + 'bloodgroup/getbloodgroup',



  //Emp
  insertEmpUrl: baseUrl + 'emp/insertemp',
  setEmpUrl: baseUrl + 'emp/setemp',
  setEmpPopUrl: baseUrl + 'emp/setemppop',
  checkEmpUrl: baseUrl + 'emp/checkemp',
  getEmpUrl: baseUrl + 'emp/getemp',
  getEmpListViewUrl: baseUrl + 'emp/getemplistview',
  deleteEmpUrl: baseUrl + 'emp/deleteemp',

  getEmpNextPrevious: baseUrl + 'emp/getempnextprevious',
  insertEmpimportUrl: baseUrl + 'emp/insertempimport',


  //EmpAsset
  insertEmpAssetUrl: baseUrl + 'emp/insertempasset',
  setEmpAssetUrl: baseUrl + 'emp/setempasset',
  setEmpAssetReturnUrl: baseUrl + 'emp/setempassetreturn',
  deleteEmpAssetUrl: baseUrl + 'emp/deleteempasset',

  //EmpPay
  insertEmpPayUrl: baseUrl + 'emp/insertemppay',
  setEmpPayUrl: baseUrl + 'emp/setemppay',
  deleteEmpPayUrl: baseUrl + 'emp/deleteemppay',

  //EmpSkills
  insertEmpSkillsUrl: baseUrl + 'emp/insertempskills',
  setEmpSkillsUrl: baseUrl + 'emp/setempskills',
  deleteEmpSkillsUrl: baseUrl + 'emp/deleteempskills',

  //Expense
  insertExpenseUrl: baseUrl + 'expense/insertexpense',
  setExpenseUrl: baseUrl + 'expense/setexpense',
  getExpenseUrl: baseUrl + 'expense/getexpense',
  getExpenseListviewUrl: baseUrl + 'expense/getexpenselistview',
  deleteExpenseUrl: baseUrl + 'expense/deleteexpense',

  //Leave
  insertLeaveUrl: baseUrl + 'leave/insertleave',
  setLeaveUrl: baseUrl + 'leave/setleave',
  getLeaveUrl: baseUrl + 'leave/getleave',
  getLeaveListviewUrl: baseUrl + 'leave/getleavelistview',
  deleteLeaveUrl: baseUrl + 'leave/deleteleave',
  checkLeaveUrl: baseUrl + 'leave/checkleave',
  setLeaveOptionUrl: baseUrl + 'leave/setleaveoption',
  setLeaveCancelUrl: baseUrl + 'leave/setleavecancel',

  //Incident
  insertIncidentUrl: baseUrl + 'incidents/insertincidents',
  setIncidentUrl: baseUrl + 'incidents/setincidents',
  getIncidentUrl: baseUrl + 'incidents/getincidents',
  getIncidentListviewUrl: baseUrl + 'incidents/getincidentslistview',
  deleteIncidentUrl: baseUrl + 'incidents/deleteincidents',



  //Bonus
  insertBonusUrl: baseUrl + 'bonus/insertbonus',
  setBonusUrl: baseUrl + 'bonus/setbonus',
  getBonusUrl: baseUrl + 'bonus/getbonus',
  getBonusListviewUrl: baseUrl + 'bonus/getbonuslistview',
  deleteBonusUrl: baseUrl + 'bonus/deletebonus',
  checkBonusUrl: baseUrl + 'bonus/checkbonus',
  insertBonusBulkUrl: baseUrl + 'bonus/insertbonusbulk',

  //Reimburse
  insertReimburseUrl: baseUrl + 'reimburse/insertreimburse',
  setReimburseUrl: baseUrl + 'reimburse/setreimburse',
  getReimburseUrl: baseUrl + 'reimburse/getreimburse',
  getReimburseListviewUrl: baseUrl + 'reimburse/getreimburselistview',
  deleteReimburseUrl: baseUrl + 'reimburse/deletereimburse',
  checkReimburseUrl: baseUrl + 'reimburse/checkreimburse',

  //Memo
  insertMemoUrl: baseUrl + 'memo/insertmemo',
  setMemoUrl: baseUrl + 'memo/setmemo',
  getMemoUrl: baseUrl + 'memo/getmemo',
  getMemoListviewUrl: baseUrl + 'memo/getmemolistview',
  deleteMemoUrl: baseUrl + 'memo/deletememo',
  getPriorityUrl: baseUrl + 'memo/getpriority',

  //Training
  insertTrainingUrl: baseUrl + 'training/inserttraining',
  setTrainingUrl: baseUrl + 'training/settraining',
  getTrainingUrl: baseUrl + 'training/gettraining',
  getTrainingListviewUrl: baseUrl + 'training/gettraininglistview',
  deleteTrainingUrl: baseUrl + 'training/deletetraining',


  //Payadv
  insertPayadvUrl: baseUrl + 'payadv/insertpayadv',
  setPayadvUrl: baseUrl + 'payadv/setpayadv',
  getPayadvUrl: baseUrl + 'payadv/getpayadv',
  getPayadvListviewUrl: baseUrl + 'payadv/getpayadvlistview',
  deletePayadvUrl: baseUrl + 'payadv/deletepayadv',
  checkPayadvUrl: baseUrl + 'payadv/checkpayadv',


  //Transfer
  insertTransferUrl: baseUrl + 'transfer/inserttransfer',
  setTransferUrl: baseUrl + 'transfer/settransfer',
  getTransferUrl: baseUrl + 'transfer/gettransfer',
  getTransferListviewUrl: baseUrl + 'transfer/gettransferlistview',
  deleteTransferUrl: baseUrl + 'transfer/deletetransfer',
  checkTransferUrl: baseUrl + 'transfer/checktransfer',

  //Overtime
  insertOvertimeUrl: baseUrl + 'overtime/insertovertime',
  setOvertimeUrl: baseUrl + 'overtime/setovertime',
  getOvertimeUrl: baseUrl + 'overtime/getovertime',
  getOvertimeListviewUrl: baseUrl + 'overtime/getovertimelistview',
  deleteOvertimeUrl: baseUrl + 'overtime/deleteovertime',

  insertOvertimeimportUrl: baseUrl + 'overtime/insertovertimeimport',


  //Loan
  insertLoanUrl: baseUrl + 'loan/insertloan',
  setLoanUrl: baseUrl + 'loan/setloan',
  getLoanUrl: baseUrl + 'loan/getloan',
  getLoanListviewUrl: baseUrl + 'loan/getloanbylistview',
  deleteLoanUrl: baseUrl + 'loan/deleteloan',

  insertLoandetUrl: baseUrl + 'loan/insertloandet',
  setLoandetUrl: baseUrl + 'loan/setloandet',
  deleteLoandetUrl: baseUrl + 'loan/deleteloandet',
  setLoanPauseUrl: baseUrl + 'loan/setloanpause',

  //Payroll
  getPayrollPeriodUrl: baseUrl + 'payroll/getpayrollperiod',
  checkPayrollGenerateUrl: baseUrl + 'payroll/checkpayrollgenerate',

  getPayrollGenerateUrl: baseUrl + 'payroll/getpayrollgenerate',
  getPayrollByPayrollidUrl: baseUrl + 'payroll/getpayrollbypayrollid',
  getPayrollByListviewUrl: baseUrl + 'payroll/getpayrollbylistview',
  getPayrollByEmpidUrl: baseUrl + 'payroll/getpayrollbyempid',
  deletePayrollUrl: baseUrl + 'payroll/deletepayroll',

  insertPayrollLOPUrl: baseUrl + 'payroll/insertpayrolllinelop',
  setPayrollLOPUrl: baseUrl + 'payroll/setpayrolllinelop',
  setPayrollRemoveTransactionUrl: baseUrl + 'payroll/setpayrollremovetransaction',
  getPayrollPeriodDisplayUrl: baseUrl + 'payroll/getpayrollperioddisplay',
  getPayrollWPSFormatUrl: baseUrl + 'payroll/getpayrollwpsformat',

  //Annualleave
  insertAnnualleaveUrl: baseUrl + 'annualleave/insertannualleave',
  setAnnualleaveUrl: baseUrl + 'annualleave/setannualleave',
  getAnnualleaveUrl: baseUrl + 'annualleave/getannualleave',
  getAnnualleaveListviewUrl: baseUrl + 'annualleave/getannualleavelistview',
  deleteAnnualleaveUrl: baseUrl + 'annualleave/deleteannualleave',



  //Documents
  insertDocumentUrl: baseUrl + 'document/insertdocument',
  setDocumentUrl: baseUrl + 'document/setdocument',
  insertDocumentDetailsUrl: baseUrl + 'document/insertdocumentdetails',
  getDocumentByDocumentidUrl: baseUrl + 'document/getdocumentbydocumentid',
  getDocumentDetailsByDocumentDetailsidUrl: baseUrl + 'document/getdocumentdetailsbydocumentdetailsid',
  deleteDocumentUrl: baseUrl + 'document/deletedocument',
  deleteDocumentDetailsUrl: baseUrl + 'document/deletedocumentdetails',

  insertAttachmentUrl: baseUrl + 'document/insertattachment',
  getAttachmentByAttachmentidUrl: baseUrl + 'document/getattachmentbyattachmentid',
  deleteAttachmentUrl: baseUrl + 'document/deleteattachment',
  getAttachmentCountByTrxidUrl: baseUrl + 'document/getattachmentcountbytrxid',

  //Leavesalary
  insertLeavesalaryUrl: baseUrl + 'leavesalary/insertleavesalary',
  setLeavesalaryUrl: baseUrl + 'leavesalary/setleavesalary',
  getLeavesalaryUrl: baseUrl + 'leavesalary/getleavesalary',
  getLeavesalaryListviewUrl: baseUrl + 'leavesalary/getleavesalarylistview',
  deleteLeavesalaryUrl: baseUrl + 'leavesalary/deleteleavesalary',
  checkLeavesalaryUrl: baseUrl + 'leavesalary/checkleavesalary',



  //Payadj
  insertPayadjUrl: baseUrl + 'payadj/insertpayadj',
  setPayadjUrl: baseUrl + 'payadj/setpayadj',
  getPayadjUrl: baseUrl + 'payadj/getpayadj',
  getPayadjListviewUrl: baseUrl + 'payadj/getpayadjlistview',
  deletePayadjUrl: baseUrl + 'payadj/deletepayadj',
  getPayadjdetailsByEmpUrl: baseUrl + 'payadj/getpayadjdetailsbyempid',
  checkPayadjUrl: baseUrl + 'payadj/checkpayadj',

  //Approvals          
  insertApprovalsUrl: baseUrl + 'approvals/insertapprovals',
  getApprovalsFormsUrl: baseUrl + 'approvals/getapprovalsbyforms',
  getApprovalsListviewUrl: baseUrl + 'approvals/getapprovalslistview',
  setTranspaymentinfoUrl: baseUrl + 'approvals/settranspaymentinfo',
  setRemovePaymentUrl: baseUrl + 'approvals/setremovepayment',
  //Report                  
  getDocumentExpiryUrl: baseUrl + 'report/getreportdocumentexpiry',
  getReportEmployeeSummaryUrl: baseUrl + 'report/getreportemployeesummary',
  getActivitylogReportUrl: baseUrl + 'report/getreportactivitylog',
  getLeaveReportUrl: baseUrl + 'report/getreportleave',
  getAssetReportUrl: baseUrl + 'report/getreportasset',
  getTrainingReportUrl: baseUrl + 'report/getreporttraining',
  getOvertimeReportUrl: baseUrl + 'report/getreportovertime',
  getPayrollSummaryReportUrl: baseUrl + 'report/getreportpayrollsummary',
  getEmployeepayReportUrl: baseUrl + 'report/getreportemployeepay',
  getPayadvReportUrl: baseUrl + 'report/getreportpayadv',
  getEmpSalaryReportUrl: baseUrl + 'report/getreportemployeesalary',
  getLoanSummaryReportUrl: baseUrl + 'report/getreportloansummary',
  getLoanOutstandingSummaryReportUrl: baseUrl + 'report/getreportloanoutstandingsummary',
  getInsuranceReportUrl: baseUrl + 'report/getreportinsurance',
  getAttendanceReportUrl: baseUrl + 'report/getreportattendance',
  getAttendanceSummaryReportUrl: baseUrl + 'report/getreportattendancesummary',
  getEmpRequestdetailsReportUrl: baseUrl + 'report/getreportemprequestdetails',
  getEmpPersonalDetReportUrl: baseUrl + 'report/getreportemppersonaldetails',
  getHeadCountReportUrl: baseUrl + 'report/getreportheadcount',
  getFinalsettlementReportUrl: baseUrl + 'report/getreportfinalsettlement',
  getHolidaysReportUrl: baseUrl + 'report/getreportholidays',
  getInoutPunchDetailsReportUrl: baseUrl + 'report/getreportinoutpunchdetails',
  getInoutPunchReportUrl: baseUrl + 'report/getreportinoutpunch',
  getPaymentListviewReportUrl: baseUrl + 'report/getreportpaymentlistview',
  getUserappformUrl: baseUrl + 'report/getuserappform',


  //--------Common  
  insertactivitylogUrl: baseUrl + 'common/insertactivitylog',
  getActivitylogbyTransactionUrl: baseUrl + 'common/getactivitylogbytransaction',

  //Bankbranch
  insertBankbranchUrl: baseUrl + 'bankbranch/insertbankbranch',
  setBankbranchUrl: baseUrl + 'bankbranch/setbankbranch',
  getBankbranchUrl: baseUrl + 'bankbranch/getbankbranch',
  deleteBankbranchUrl: baseUrl + 'bankbranch/deletebankbranch',
  checkBankbranchUrl: baseUrl + 'bankbranch/checkbankbranch',

  //Alerttype
  insertAlerttypeUrl: baseUrl + 'alerttype/insertalerttype',
  setAlerttypeUrl: baseUrl + 'alerttype/setalerttype',
  getAlerttypeUrl: baseUrl + 'alerttype/getalerttype',
  deleteAlerttypeUrl: baseUrl + 'alerttype/deletealerttype',
  checkAlerttypeUrl: baseUrl + 'alerttype/checkalerttype',


  //Settings

  setSettingsUrl: baseUrl + 'settings/setsettings',
  getSettingsUrl: baseUrl + 'settings/getsettings',


  //Currency
  insertCurrencyUrl: baseUrl + 'currency/insertcurrency',
  setCurrencyUrl: baseUrl + 'currency/setcurrency',
  getCurrencyUrl: baseUrl + 'currency/getcurrency',
  deleteCurrencyUrl: baseUrl + 'currency/deletecurrency',
  checkCurrencyUrl: baseUrl + 'currency/checkcurrency',


  //Expensepolicy
  insertExpensepolicyUrl: baseUrl + 'expensepolicy/insertexpensepolicy',
  setExpensepolicyUrl: baseUrl + 'expensepolicy/setexpensepolicy',
  getExpensepolicyUrl: baseUrl + 'expensepolicy/getexpensepolicy',
  deleteExpensepolicyUrl: baseUrl + 'expensepolicy/deleteexpensepolicy',
  checkExpensepolicyUrl: baseUrl + 'expensepolicy/checkexpensepolicy',
  getExpensepolicyListviewUrl: baseUrl + 'expensepolicy/getexpensepolicylistview',



  //Scheduletemplate
  insertScheduletemplateUrl: baseUrl + 'scheduletemplate/insertscheduletemplate',
  setScheduletemplateUrl: baseUrl + 'scheduletemplate/setscheduletemplate',
  getScheduletemplateUrl: baseUrl + 'scheduletemplate/getscheduletemplate',
  deleteScheduletemplateUrl: baseUrl + 'scheduletemplate/deletescheduletemplate',
  checkScheduletemplateUrl: baseUrl + 'scheduletemplate/checkscheduletemplate',


  //Ptaxmain
  insertPtaxmainUrl: baseUrl + 'ptaxmain/insertptaxmain',
  setPtaxmainUrl: baseUrl + 'ptaxmain/setptaxmain',
  checkPtaxmainUrl: baseUrl + 'ptaxmain/checkptaxmain',
  getPtaxmainUrl: baseUrl + 'ptaxmain/getptaxmain',
  deletePtaxmainUrl: baseUrl + 'ptaxmain/deleteptaxmain',
  getPtaxmainListviewUrl: baseUrl + 'ptaxmain/getptaxmainlistview',

  //TransPayMode
  insertTransPaymodeUrl: baseUrl + 'transpaymode/inserttranspaymode',
  setTransPaymodeUrl: baseUrl + 'transpaymode/settranspaymode',
  checkTransPaymodeUrl: baseUrl + 'transpaymode/checktranspaymode',
  getTransPaymodeUrl: baseUrl + 'transpaymode/gettranspaymode',
  deleteTransPaymodeUrl: baseUrl + 'transpaymode/deletetranspaymode',



  //FineType
  insertFineTypeUrl: baseUrl + 'finetype/insertfinetype',
  setFineTypeUrl: baseUrl + 'finetype/setfinetype',
  checkFineTypeUrl: baseUrl + 'finetype/checkfinetype',
  getFineTypeUrl: baseUrl + 'finetype/getfinetype',
  deleteFineTypeUrl: baseUrl + 'finetype/deletefinetype',


  //Fine
  insertFineUrl: baseUrl + 'fine/insertfine',
  setFineUrl: baseUrl + 'fine/setfine',
  checkFineUrl: baseUrl + 'fine/checkfine',
  getFineUrl: baseUrl + 'fine/getfine',
  getFineListviewUrl: baseUrl + 'fine/getfinelistview',
  deleteFineUrl: baseUrl + 'fine/deletefine',


  //Promotion
  insertPromotionUrl: baseUrl + 'promotion/insertpromotion',
  setPromotionUrl: baseUrl + 'promotion/setpromotion',
  getPromotionUrl: baseUrl + 'promotion/getpromotion',
  getPromotionListviewUrl: baseUrl + 'promotion/getpromotionlistview',
  deletePromotionUrl: baseUrl + 'promotion/deletepromotion',



  //RequestType
  insertRequestTypeUrl: baseUrl + 'requesttype/insertrequesttype',
  setRequestTypeUrl: baseUrl + 'requesttype/setrequesttype',
  checkRequestTypeUrl: baseUrl + 'requesttype/checkrequesttype',
  getRequestTypeUrl: baseUrl + 'requesttype/getrequesttype',
  deleteRequestTypeUrl: baseUrl + 'requesttype/deleterequesttype',


  //OtherRequest
  insertOtherRequestUrl: baseUrl + 'otherrequest/insertotherrequest',
  setOtherRequestUrl: baseUrl + 'otherrequest/setotherrequest',
  getOtherRequestUrl: baseUrl + 'otherrequest/getotherrequest',
  getOtherRequestListviewUrl: baseUrl + 'otherrequest/getotherrequestlistview',
  deleteOtherRequestUrl: baseUrl + 'otherrequest/deleteotherrequest',



  //EmpDetailsChange
  insertEmpDetailsChangeUrl: baseUrl + 'empdetailschange/insertempdetailschange',
  setEmpDetailsChangeUrl: baseUrl + 'empdetailschange/setempdetailschange',
  getEmpDetailsChangeUrl: baseUrl + 'empdetailschange/getempdetailschange',
  getEmpDetailsChangeListviewUrl: baseUrl + 'empdetailschange/getempdetailschangelistview',
  deleteEmpDetailsChangeUrl: baseUrl + 'empdetailschange/deleteempdetailschange',
  checkEmpDetailsChangeUrl: baseUrl + 'empdetailschange/checkempdetailschange',
  insertEmpDetailsChangeBulkUrl: baseUrl + 'empdetailschange/insertempdetailschangebulk',


  //ShorttermPay
  insertShorttermPayUrl: baseUrl + 'shorttermpay/insertshorttermpay',
  setShorttermPayUrl: baseUrl + 'shorttermpay/setshorttermpay',
  getShorttermPayUrl: baseUrl + 'shorttermpay/getshorttermpay',
  getShorttermPayListviewUrl: baseUrl + 'shorttermpay/getshorttermpaylistview',
  deleteShorttermPayUrl: baseUrl + 'shorttermpay/deleteshorttermpay',
  setShorttermPaySuspendUrl: baseUrl + 'shorttermpay/setshorttermpaysuspend',
  checkShorttermPayUrl: baseUrl + 'shorttermpay/checkshorttermpay',

  //InsuranceType
  insertInsuranceTypeUrl: baseUrl + 'insurancetype/insertinsurancetype',
  setInsuranceTypeUrl: baseUrl + 'insurancetype/setinsurancetype',
  checkInsuranceTypeUrl: baseUrl + 'insurancetype/checkinsurancetype',
  getInsuranceTypeUrl: baseUrl + 'insurancetype/getinsurancetype',
  deleteInsuranceTypeUrl: baseUrl + 'insurancetype/deleteinsurancetype',


  //InsuranceCompany
  insertInsuranceCompanyUrl: baseUrl + 'insurancecompany/insertinsurancecompany',
  setInsuranceCompanyUrl: baseUrl + 'insurancecompany/setinsurancecompany',
  checkInsuranceCompanyUrl: baseUrl + 'insurancecompany/checkinsurancecompany',
  getInsuranceCompanyUrl: baseUrl + 'insurancecompany/getinsurancecompany',
  deleteInsuranceCompanyUrl: baseUrl + 'insurancecompany/deleteinsurancecompany',


  //Reason
  insertReasonUrl: baseUrl + 'reason/insertreason',
  setReasonUrl: baseUrl + 'reason/setreason',
  checkReasonUrl: baseUrl + 'reason/checkreason',
  getReasonUrl: baseUrl + 'reason/getreason',
  deleteReasonUrl: baseUrl + 'reason/deletereason',

  //Insurance
  insertInsuranceUrl: baseUrl + 'insurance/insertinsurance',
  setInsuranceUrl: baseUrl + 'insurance/setinsurance',
  getInsuranceUrl: baseUrl + 'insurance/getinsurance',
  getInsuranceListviewUrl: baseUrl + 'insurance/getinsurancelistview',
  deleteInsuranceUrl: baseUrl + 'insurance/deleteinsurance',
  checkInsuranceUrl: baseUrl + 'insurance/checkinsurance',


  //Airticket
  insertAirticketUrl: baseUrl + 'airticket/insertairticket',
  setAirticketUrl: baseUrl + 'airticket/setairticket',
  getAirticketUrl: baseUrl + 'airticket/getairticket',
  getAirticketListviewUrl: baseUrl + 'airticket/getairticketlistview',
  deleteAirticketUrl: baseUrl + 'airticket/deleteairticket',
  checkAirticketUrl: baseUrl + 'airticket/checkairticket',



  //FinalSettlement
  insertFinalSettlementUrl: baseUrl + 'finalsettlement/insertfinalsettlement',
  setFinalSettlementUrl: baseUrl + 'finalsettlement/setfinalsettlement',
  getFinalSettlementUrl: baseUrl + 'finalsettlement/getfinalsettlement',
  getFinalSettlementListviewUrl: baseUrl + 'finalsettlement/getfinalsettlementlistview',
  deleteFinalSettlementUrl: baseUrl + 'finalsettlement/deletefinalsettlement',
  checkFinalSettlementUrl: baseUrl + 'finalsettlement/checkfinalsettlement',

  //Dashboard
  getDashboardUrl: baseUrl + 'dashboard/getdashboard',



}

